import { axios } from "@v2/shared/api";

const endpoint = participantId =>
  `participants/${participantId}/equipment-letters`;

export default {
  getAll(participantId, page = 1) {
    return axios.get(`${endpoint(participantId)}?page=${page}`);
  },

  add(participantId, letter) {
    return axios.post(endpoint(participantId), letter);
  },

  update(participantId, letterId, letter) {
    return axios.put(`${endpoint(participantId)}/${letterId}`, letter);
  },

  send(participantId, letter, letterId = null) {
    const url = letterId
      ? `${endpoint(participantId)}/${letterId}`
      : endpoint(participantId);
    return axios.post(`${url}/send`, letter);
  },

  download(participantId, letterId) {
    return axios.get(`${endpoint(participantId)}/${letterId}/download`, {
      responseType: "arraybuffer"
    });
  }
};
